module.exports = __webpack_public_path__ + "img/aws-svgrepo-com.ab474cf8.svg";